// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseStatusEntity from './entities/case-status.json';
import caseStatusMenu from '../pages/case-status/menu.json';
import caseStatusFullForm from '../pages/case-status/forms/full.json';
import caseStatusContextForm from '../pages/case-status/forms/context.json';
import caseStatusMiniForm from '../pages/case-status/forms/mini.json';
import caseStatusLookupForm from '../pages/case-status/forms/lookup.json';
import caseStatusTableView from '../pages/case-status/views/table.json';
import caseStatusDashboardView from '../pages/case-status/views/dashboard.json';

/** Тип запису «Статус справи» зі сторінками пакета: меню, форми та подання з pages/case-status/. */
export const caseStatusDefinition: IRecordTypeDefinition = {
  ...caseStatusEntity,
  views: assembleViewSet({
      table: caseStatusTableView,
      dashboard: caseStatusDashboardView,
  }),
  form: caseStatusFullForm,
  forms: { full: caseStatusFullForm, context: caseStatusContextForm, mini: caseStatusMiniForm, lookup: caseStatusLookupForm },
  menu: caseStatusMenu,
} as IRecordTypeDefinition;
